export default __webpack_public_path__ + "static/media/raspberry-pi.9dcf890d.svg";